import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import GlobalSEO from "./SEO"; // your existing global SEO
import { getMarketplaceData } from "../../Utility/Controller/UtilityController";
import { connect } from 'react-redux';
import { loaderStateTrue, loaderStateFalse, setGlobalSeoData } from '../../../src/Actions/AllAction';


const SeoManager = (props) => {
    const apiKey = localStorage.getItem("api_key") || "";
    const isBookingEngine = apiKey && apiKey.trim() !== "";

    const [seoData, setSeoData] = useState(null);

    useEffect(() => {
        const fetchSeoData = async () => {
            if (isBookingEngine && apiKey !== "") {
                try {
                    const response = await getMarketplaceData();
                    // console.log("Marketplace SEO Response:", response);

                    if (!response?.success) {
                        setSeoData(null);
                        return;
                    }

                    if (response?.orgDetails) {
                        const org = response.orgDetails || {};
                        const data = response.data || [];

                        let tempData = {
                            pageTitle: org?.org_name || process.env.PROJECT_NAME || "",
                            description: `${org?.org_name || process.env.PROJECT_NAME || ""} - Book your stay at ${org?.city || ''}, ${org?.state || ""}, ${org?.country || ""}. Contact: ${org?.contact_number || ""}`,
                            pageUrl: window.location.href,
                            imageUrl: JSON.parse(org?.org_logo)?.file_obj || require('../Public/images/logo.png'),
                            siteTitle: org?.org_name,
                            twitterHandle: org?.org_name?.replace(/\s+/g, "") || "InnsightAI",
                            authorHandle: "MettaStay",
                            org, // keep raw org details too
                            data
                        }
                        setSeoData(tempData);
                        props.setGlobalSeoData(tempData)
                    }
                } catch (error) {
                    console.error("Error fetching SEO data:", error);
                    setSeoData(null);
                }
            }
        };

        fetchSeoData();
    }, [isBookingEngine, apiKey]);

    useEffect(() => {
        if (seoData) {
            // console.log("SEO Data Set:", seoData);
        }
    }, [seoData]);

    // Global Marketplace
    if (!isBookingEngine) {
        // console.log("Using Global SEO");
        return <GlobalSEO />;
    }

    //   //Booking Engine - wait for SEO data
    //   if (!seoData) {
    //     return null; // you can add a <Loader /> here
    //   }

    return (
        <Helmet>
            {/* Booking Engine SEO */}
            <title>{seoData?.pageTitle}</title>
            <meta name="description" content={seoData?.description} />
            <link rel="canonical" href={seoData?.pageUrl} />

            {/* OG Tags */}
            <meta property="og:type" content="website" />
            <meta property="og:url" content={seoData?.pageUrl} />
            <meta property="og:title" content={seoData?.pageTitle} />
            <meta property="og:description" content={seoData?.description} />
            <meta property="og:image" content={seoData?.imageUrl} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={seoData?.pageTitle} />
            <meta name="twitter:description" content={seoData?.description} />
            <meta name="twitter:image" content={seoData?.imageUrl} />

            {/* Structured Data */}
            <script type="application/ld+json">
                {JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "WebApplication",
                    name: seoData?.siteTitle,
                    url: seoData?.pageUrl,
                    description: seoData?.description,
                    image: seoData?.imageUrl,
                    applicationCategory: "BusinessApplication",
                    operatingSystem: "All",
                })}
            </script>
        </Helmet>
    );
};


const mapStateToProps = (globalState) => ({
    isLoading: globalState.mainReducerData.loaderState,
});

export default connect(mapStateToProps, { loaderStateTrue, loaderStateFalse, setGlobalSeoData })(SeoManager);